import React from 'react'

import clsx from 'clsx'

import Avatars from 'components/Avatars'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import { handleScrollTo } from 'screens/compare/components/NavigationList/helpers'

import classes from './Contributors.module.scss'

const Contributors = ({ type, contributors }) => {
  const { addEvent } = useEventContext()

  const prefix = type === 'WRITERS' ? 'Written by ' : 'Edited by '

  return (
    <>
      <Avatars className={classes.avatars} imagesUrl={contributors.map(writer => writer.avatar.src)} imageSize={36} />
      <Typography variant="tight-xxs">
        {contributors.map(({ name, slug }, index) => {
          const linkPrefix = index === 0 ? prefix : index === contributors.length - 1 ? ' and ' : ', '

          return (
            <span key={name} className={clsx(classes.linkContainer, { [classes.inlineBlock]: linkPrefix === ' and ' })}>
              {linkPrefix}
              <Link
                disableSeo
                onClick={() => handleScrollTo(slug, 100)}
                className={classes.authorLink}
                {...addEvent({
                  name: 'engagement_facet_click',
                  engagementComponent: 'author-card',
                  engagementDestination: 'go-to_author-page',
                  engagementDetails: 'text-link_author-name',
                })}
              >
                {name}
              </Link>
            </span>
          )
        })}
      </Typography>
    </>
  )
}

export default Contributors
